// Google Analytics 4 Integration for Sereno Spa
// This file handles all GA4 tracking events and page views

// Initialize Google Analytics
export const initializeGA = (measurementId) => {
  // Load Google Analytics script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  
  gtag('js', new Date());
  gtag('config', measurementId, {
    // Enhanced measurement settings
    page_title: true,
    page_location: true,
    scroll_events: true,
    outbound_clicks: true,
    site_search: true,
    video_engagement: true,
    file_downloads: true
  });
  
  if (process.env.NODE_ENV === 'development') {
    console.log('Google Analytics initialized');
  }
};

// Track page views
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, {
      event_category: parameters.category || 'User Interaction',
      event_label: parameters.label || '',
      value: parameters.value || 0,
      ...parameters
    });
  }
};

// Spa-specific tracking events
export const trackBookingClick = (serviceName, serviceCategory) => {
  trackEvent('book_service', {
    category: 'Booking',
    label: `${serviceCategory} - ${serviceName}`,
    service_name: serviceName,
    service_category: serviceCategory
  });
};

export const trackServiceView = (serviceCategory) => {
  trackEvent('view_service_category', {
    category: 'Services',
    label: serviceCategory,
    service_category: serviceCategory
  });
};

export const trackPhoneClick = () => {
  trackEvent('contact_phone', {
    category: 'Contact',
    label: 'Phone Number Click'
  });
};

export const trackEmailClick = () => {
  trackEvent('contact_email', {
    category: 'Contact',
    label: 'Email Click'
  });
};

export const trackSocialClick = (platform) => {
  trackEvent('social_media_click', {
    category: 'Social Media',
    label: platform,
    platform: platform
  });
};

export const trackProductClick = (productName) => {
  trackEvent('product_click', {
    category: 'E-commerce',
    label: productName,
    product_name: productName
  });
};

export const trackNavigationClick = (pageName) => {
  trackEvent('navigation_click', {
    category: 'Navigation',
    label: pageName,
    page_name: pageName
  });
};

// E-commerce tracking
export const trackPurchase = (transactionId, items, value) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: 'USD',
      items: items
    });
  }
};

export const trackAddToCart = (itemName, category) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'add_to_cart', {
      currency: 'USD',
      items: [{
        item_id: itemName.toLowerCase().replace(/\s+/g, '_'),
        item_name: itemName,
        category: category,
        quantity: 1
      }]
    });
  }
};